import React from 'react'
import {useField} from 'formik'

interface Props extends React.InputHTMLAttributes<HTMLInputElement|HTMLTextAreaElement>{
  label?: string
  name: string
}

export default function Field({label, className, type, ...props}: Props) {
  const [field, meta] = useField(props.name)

  const id = `__input_id_${props.name}`

  const isInvalid = !!(meta.error && meta.touched)

  return (
    <div className={className}>
      {label && (
        <label htmlFor={id} className="form-label">{label}</label>
      )}
      {type === 'textarea' ? (
        <textarea className={`form-control ${isInvalid ? 'is-invalid' : ''}`} id={id} {...field} {...props} />
      ) : (
        <input className={`form-control ${isInvalid ? 'is-invalid' : ''}`} id={id} type={type} {...field} {...props} />
      )}
      {isInvalid && (
        <div className="invalid-feedback">{meta.error}</div>
      )}
    </div>
  )
}
